module.exports = __webpack_public_path__ + "img/3.9afa96f9.svg";